import { render, staticRenderFns } from "./TileSimpleBACKUPBAREOS.vue?vue&type=template&id=6ed804c2&"
import script from "./TileSimpleBACKUPBAREOS.vue?vue&type=script&lang=js&"
export * from "./TileSimpleBACKUPBAREOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
